import { createStore, applyMiddleware, compose } from "redux";
import thunk from "redux-thunk";

import { StoreState } from "./storeState";
import reducer from "../reducers";

export default function configureStore(initialStore: StoreState) {
  const composeEnhancers = (window as any).__REDUX_DEVTOOLS_EXTENSION_COMPOSE__ || compose;
  const store = createStore(reducer, initialStore, composeEnhancers(applyMiddleware(thunk)));

  /**
   * TODO:
   * Verify we do not need to add hot-reloading. It should be handled by `hotDevClient`
   * in WebpackDevServer.
   *
   * See `config/webpack.config.dev.js`
   *
   * If we **DO** need hot-reloading, be sure to add it here and in index.tsx.
   //  */
  //   const m: any = module;
  //   if (process.env.NODE_ENV !== "production") {
  //     if (m.hot) {
  //       m.hot.accept("../reducers", () => {
  //         store.replaceReducer(reducer);
  //       });
  //     }
  //   }

  return store;
}
